import SignupRedirect from './SignUpRedirect';

export default SignupRedirect;
